import React from "react";
import Button from "react-bootstrap/Button";
import Card from "react-bootstrap/Card";
import Col from "react-bootstrap/Col";
import { Link } from "react-router-dom";

export const NavigationBoxes = ({
    navTitle,
    navDescription,
    navButtonText,
    pageName,
}) => {
    return (
        <>
            <Col xs={12} lg={3} className="text-center rounded-3 py-2 my-2 ">
                <Card>
                    <Card.Body>
                        <Card.Title>{navTitle}</Card.Title>
                        <Card.Text>{navDescription}</Card.Text>
                        <Link to={pageName}>
                            <Button variant="primary">{navButtonText}</Button>
                        </Link>
                    </Card.Body>
                </Card>
            </Col>
        </>
    );
};
